module.exports = __webpack_public_path__ + "static/media/netmap.8d1a7a02.png";